import React from 'react'

import Icons from './../../../utils/import.icons'

interface Props{
    isSidebarHidden: boolean
    isBeneficios: boolean
    proyecto: any
    secondaryBtnSelected: string
    handleShowBeneficios: any
}

interface State{}

interface Info {
    Icons?: any
}

class BeneficiosSidebar extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {}
    }

    handleCreateButtonsStructure = () => {
        const ameniadesIcons: Info = {Icons}
        return(
            this.props.proyecto.map((POI: any, index: number) => 
                <React.Fragment key={(index+2)*2}>
                    <div 
                    className={this.props.secondaryBtnSelected === POI.nombre ? "btn-sidebar-beneficios selected": this.props.isSidebarHidden ? "btn-sidebar-beneficios-collapsed":"btn-sidebar-beneficios"} 
                    key={index} 
                    onClick={() => {this.props.handleShowBeneficios(POI.nombre, ameniadesIcons.Icons[POI.nombre+"2"], POI)}}
                    >
                        <img src={ameniadesIcons.Icons[this.props.secondaryBtnSelected === POI.nombre ? POI.nombre+"2":POI.nombre]} alt=''/>
                        <div>{POI.nombre}</div>
                    </div>
                    <hr className='secondary-bar-hr' key={(index+1)*2}/>
                </React.Fragment>
            )
        )
    }

    render(): React.ReactNode {
        return(
            <div className={!this.props.isSidebarHidden && this.props.isBeneficios ? 'beneficios-sidebar':'beneficios-collapsed'}>
                {
                    this.handleCreateButtonsStructure()
                }
            </div>
        )
    }
}

export default BeneficiosSidebar